import * as React from "react";
import { useEffect } from "react";
import { Multi_SkillTag } from "src/domain/model/skill_tag";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import { PastCaseProject } from "../../../../domain/model/past_case_project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import PastProjectEditForm from "./edit/past_project_edit_form";

interface IProps {
  isLoading: boolean;
  customer: Customer | null;
  jobCareers: JobCareer[];
  pastCaseProjects: PastCaseProject[];
  handleUpdateCustomerSubmit: (values: any) => void;
}

const PastProjectEditComponent: React.FC<IProps> = (props) => {
  const {
    isLoading,
    customer,
    jobCareers,
    pastCaseProjects,
    handleUpdateCustomerSubmit,
  } = props;

  const initialValues = {
    customer,
    jobCareers,
    pastCaseProjects,
    tags_1: customer!.multiSkillTags
      .filter(
        (v) =>
          v.category === Multi_SkillTag.Category.Category_IntroductionOperation
      )
      .map((v) => v.id),
    tags_7: customer!.multiSkillTags
      .filter(
        (v) =>
          v.category === Multi_SkillTag.Category.Category_PersonalConnections
      )
      .map((v) => v.id),
    tags_5: customer!.multiSkillTags
      .filter(
        (v) => v.category === Multi_SkillTag.Category.Category_DevelopFramework
      )
      .map((v) => v.id),
    tags_3: customer!.multiSkillTags
      .filter(
        (v) => v.category === Multi_SkillTag.Category.Category_OverseasExpansion
      )
      .map((v) => v.id),
    tags_4: customer!.multiSkillTags
      .filter(
        (v) => v.category === Multi_SkillTag.Category.Category_Programming
      )
      .map((v) => v.id),
    tags_6: customer!.multiSkillTags
      .filter((v) => v.category === Multi_SkillTag.Category.Category_AI)
      .map((v) => v.id),
  };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.customerRoot,
    routeConfig.customerMypage,
    routeConfig.customerMypageEdit,
  ];

  useEffect(() => {
    window.addEventListener("beforeunload", onUnload);

    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  });

  const onUnload = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  return (
    <div>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        <PastProjectEditForm
          // For Redux-Form
          initialValues={initialValues}
          onSubmit={handleUpdateCustomerSubmit}
          enableReinitialize={true}
        />
      </PageWrapper>
    </div>
  );
};

export default PastProjectEditComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/past_project_edit.tsx